<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="'Invoice Next'" :directory="$t('transaction')" :icon="'grid'"/>
            </div>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button">
            </div>
        </div>

        <app-table
            :id="tableId"
            :options="options"
            @action="getListAction"
        />

        <apps-detail 
            v-if="isAddEditModalActive" 
            :selected-url="selectedUrl"
            :modal-id="'apps-detail'" 
            :table-id="tableId" 
            @close-modal="closeAddEditModal" />
    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import {Schema} from './Schema';
import AppsDetail from "./AppsDetail";
export default {
    extends: CoreLibrary,
    name: "InvoiceNext",
    mixins: [Schema],
    components: {
        'apps-detail': AppsDetail
    },
    created() {
        this.options.columns = [...this.tableColumns];
    },
	mounted() {
		window.HandleDetailApps = (id) => {
			this.openDetailApps(id);
		};
    },
    methods: {
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },
        openDetailApps(id){
            this.selectedUrl = `transaction/continue-list/${id}`;
            this.openAddEditModal();
        },

        getListAction(rowData, actionObj, active) {
        },
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },
        closeAddEditModal() {
            let m_id = `#apps-detail`;
            $(m_id).modal('hide');
            this.isAddEditModalActive = false;
        },
    },
}
</script>
